import axios from 'axios';

const BASE_URL = 'https://casacru.somee.com/api/v1';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // puedes agregar más configuraciones aquí si lo necesitas
});

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  // puedes agregar más configuraciones aquí si lo necesitas
});

export default {
  // Método para obtener todos los registros
  GetAllOfertas() {
    return apiClient.get('/Ofertas/GetAllOfertas');
  },
  GetProductsByOferta(data) {
    return apiClient.get('/Ofertas/GetProductsByOferta/' + data);
  },
};
